import React from 'react';

export default function EduItem ({title, degree}) {
    return (
            <p className='edu-item right'>
                <span className= 'h4 left'> {title} </span> 
                {degree}
            </p>
    )
}